import { serviceAreas } from '../../../mocks/services';

export default function ServiceAreasSection() {
  return (
    <section id="service-areas" className="py-16 sm:py-20 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-block bg-cyan-500 text-white px-4 py-2 rounded-full text-sm sm:text-base font-bold mb-4">
            PROUDLY SERVING THE LAS VEGAS VALLEY
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-4">
            Our Service Areas — Clark County &amp; Beyond
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            We provide professional leak detection and plumbing services throughout Clark County and surrounding communities. No matter where you are in the valley, Leak Detectives is ready to help.
          </p>
        </div>

        {/* Map and Cities - Stacked on mobile, side-by-side on desktop */}
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 sm:gap-8 mb-12">
          {/* Map - Reduced height on mobile */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden h-[250px] sm:h-[400px] lg:h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d103275.69769811895!2d-115.23804483183494!3d36.01136577319997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601c28fa621f05eb%3A0x5a496c57e1011c6f!2sLeak%20Detectives%20LLC!5e0!3m2!1sen!2sus!4v1773703449086!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Leak Detectives Location Map"
            ></iframe>
          </div>

          {/* Cities List */}
          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8">
            <h3 className="text-2xl sm:text-3xl font-black text-[#0f1f3d] mb-6 flex items-center gap-2">
              <i className="ri-map-pin-fill text-cyan-500"></i>
              Cities We Serve
            </h3>
            {/* 2-column on mobile, 2-column on desktop */}
            <div className="grid grid-cols-2 gap-3 max-h-[420px] overflow-y-auto pr-2">
              {serviceAreas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 p-3 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg hover:from-cyan-100 hover:to-blue-100 transition-all duration-300 hover:shadow-md cursor-pointer"
                >
                  <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-cyan-600 text-base sm:text-lg"></i>
                  </div>
                  <span className="text-xs sm:text-sm lg:text-base font-semibold text-[#0f1f3d]">{area}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                <strong className="text-[#0f1f3d]">Available 24/7 throughout Clark County.</strong> If you don't see your city listed, give us a call — we likely serve your area too!
              </p>
            </div>
          </div>
        </div>

        {/* About Us Card - Single column on mobile, image hidden on mobile */}
        <div className="bg-gradient-to-r from-[#0a1628] to-[#162447] rounded-2xl shadow-2xl overflow-hidden">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Text Content */}
            <div className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
              <h3 className="text-2xl sm:text-3xl font-black text-white mb-4 sm:mb-6">
                ABOUT US: LEAK DETECTIVES
              </h3>
              <p className="text-gray-200 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
                With years of experience serving the Las Vegas community, Leak Detectives has built a reputation for excellence, reliability, and customer satisfaction. Our team of licensed and insured professionals is dedicated to providing top-quality leak detection and plumbing services for both residential and commercial properties.
              </p>
              <p className="text-gray-200 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
                We understand that plumbing issues can be stressful and disruptive. That's why we offer 24/7 emergency services, flat-rate pricing, and a commitment to getting the job done right the first time.
              </p>
              {/* Badges - Stacked on mobile */}
              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-fill text-xl sm:text-2xl text-cyan-400"></i>
                  <span className="text-white font-semibold text-sm sm:text-base">Licensed &amp; Insured</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-fill text-xl sm:text-2xl text-cyan-400"></i>
                  <span className="text-white font-semibold text-sm sm:text-base">24/7 Emergency Service</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-star-fill text-xl sm:text-2xl text-cyan-400"></i>
                  <span className="text-white font-semibold text-sm sm:text-base">5-Star Rated</span>
                </div>
              </div>
            </div>
            {/* Image - Hidden on mobile, visible on desktop */}
            <div className="relative h-full min-h-[300px] sm:min-h-[400px] hidden lg:block">
              <img
                src="https://public.readdy.ai/ai/img_res/bf33fdb6ed44c802b3158b60db43c194.jpg"
                alt="Professional Plumber at Work"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}